import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiGet } from "../service/apiService";
import { endPoint } from "../config/endPoint";


export const overallcountget = createAsyncThunk("overallcountget",async (payload) => {
    const response = await apiGet(endPoint.over_count , payload, "");
    return response
}
)